export default class SideMenuObject {
    constructor (icon, name, mode = 'tab', routeName = null, hasPermissions = true, counter = false, action = () => {}, disabled = false) {
        this.icon = icon
        this.name = name
        this.mode = mode
        this.routeName = routeName
        this.hasPermissions = hasPermissions
        this.counter = counter
        this.action = action
        this.disabled = disabled
    }
}
